import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';

import featureFlagsReducer from './featureFlags';
import adminBrandsReducer from './adminBrands';
import adminCategoriesReducer from './adminCategories';
import adminPropertiesReducer from './adminProperties';
import salesChannelsReducer from './salesChannels';
import adminProductsReducer from './adminProducts';
import localesReducer from './locales';
import uiReducer from './ui';
import editingLocaleReducer from './editingLocale';
import adminBundlesReducer from './adminBundles';
import adminCountriesReducer from './adminCountries';

export const initialState = {};

const rootReducer = combineReducers({
  featureFlags: featureFlagsReducer,
  adminBrands: adminBrandsReducer,
  adminCategories: adminCategoriesReducer,
  adminProperties: adminPropertiesReducer,
  salesChannels: salesChannelsReducer,
  locales: localesReducer,
  ui: uiReducer,
  adminProducts: adminProductsReducer,
  editingLocale: editingLocaleReducer,
  adminBundles: adminBundlesReducer,
  adminCountries: adminCountriesReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export type AppDispatch = typeof store.dispatch;

export type AsyncThunkConfig = {
  /** return type for `thunkApi.getState` */
  state?: unknown;
  /** type for `thunkApi.dispatch` */
  dispatch?: AppDispatch;
  /** type of the `extra` argument for the thunk middleware, which will be passed in as `thunkApi.extra` */
  extra?: unknown;
  /** type to be passed into `rejectWithValue`'s first argument that will end up on `rejectedAction.payload` */
  rejectValue?: unknown;
  /** return type of the `serializeError` option callback */
  serializedErrorType?: unknown;
  /** type to be returned from the `getPendingMeta` option callback & merged into `pendingAction.meta` */
  pendingMeta?: unknown;
  /** type to be passed into the second argument of `fulfillWithValue` to finally be merged into `fulfilledAction.meta` */
  fulfilledMeta?: unknown;
  /** type to be passed into the second argument of `rejectWithValue` to finally be merged into `rejectedAction.meta` */
  rejectedMeta?: unknown;
};

export default store;
